"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_DELAY_MS = void 0;
exports.MAX_DELAY_MS = 5 * 60 * 1000;
